import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

const ResearchReportsCountyFilter = ({
  facets,
  filters,
  setFilter,
  removeFilter,
}) => {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="county"
      filters={filters}
      id="county"
      label="County"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
};

export default withSearch(({ facets, filters, setFilter, removeFilter }) => ({
  facets,
  filters,
  setFilter,
  removeFilter,
}))(ResearchReportsCountyFilter);
